module.exports = __webpack_public_path__ + "img/useFlow-small-bg4.e1085e5.png";